module.exports = __webpack_public_path__ + "static/media/dotted_circle.06f47067.svg";